import React from 'react'
import { Button, Input, Option, Select } from '@material-tailwind/react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const AddArticleForm = ({blogTitle,setBlogTitle,blogContent,setBlogContent,coverImage,setCoverImage,link,setLink,addCoverImage,handleAdd}) => {
  return (
    <div className='ml-[20rem] overflow-y-scroll'>
    <div>
    <h3 className='font-[NeueBold] py-2 text-[2rem]' >Add Blog</h3>
    <div className='my-3 py-3 px-6 bg-white rounded-lg'>
    <h3 className='font-[NeueMedium] my-2 text-[1rem]' >Add Blog Details</h3>
    <div>
    <div className='my-6' >
        <Input value={blogTitle} onChange={(e)=>setBlogTitle(e.target.value)} label='Enter Article Name' />
        </div>
        <div className='my-6' >
        <Input value={blogContent} onChange={(e)=>setBlogContent(e.target.value)} label='Enter v Content' />
        </div>
        <div className='my-6' >
        <Input value={link} onChange={(e)=>setLink(e.target.value)} label='Enter Article Link' />
        </div>
    </div>
    
    </div>

    </div>
    <div className='mr-3 bg-white px-6 py-6  rounded-md my-8' >
    <h3 className='mb-2 font-[NeueMedium]' >Articles Cover Image</h3>
    <div>
    <div>
                 <form  onSubmit={addCoverImage} className='form flex items-center justify-center flex-col my-6 '>
    <input type='file' />
    <Button className='my-6' type='submit' size="md">Upload Image</Button>
  </form>
  
            </div>
            <div className='flex items-center justify-start gap-6' >
               
                     { coverImage?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                            <img className='w-[200px] h-[200px]' src={coverImage} />
                        </div>}
                   
            </div>
    </div>
   
    </div>
    
   
 
    <div className='flex items-center mr-3 justify-end my-3' >
        <Button onClick={handleAdd} >Submit</Button>
    </div>
</div>
  )
}

export default AddArticleForm